<template>
    <div class="container tercero-page">
        <div class="param-title-wrap">
            <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
                <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" />
            </b-button>
            <h2 class="param-title">{{labels.title}}</h2>
        </div>
        <div class="tercero-table-block mt-4" v-if="listadoTasas?.length > 0">
            <CorporateDataTable
                :items="listadoTasasFormat"
                :fields="allFields"
                :filter-defs="tableFilterDefs"
                :labels="tableLabels"
                :default-per-page="10"
                :page-options="[10, 15, 20, 50, 100]"
                :narrow="false"
                :table-min-height="500"
                :table-max-height="500"
                @row-clicked="(item) => editTasa(item.id)"
            >
                <template #toolbar-actions>
                    <b-button size="sm" class="table-toolbar-add-btn" @click="createTasa()">
                        {{ labels.addTasa }}
                    </b-button>
                </template>
            </CorporateDataTable>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-else>
            <h5>{{ labels.noRow }}</h5> 
        </div>
        <Crear :modCrearTasa="showCrearTasa" @creado="actualizarTabla" @cierraModal="closeModal"/>
        <Editar :modEditarTasa="showEditarTasa" :infoTasa="dataTasa" @actualizado="actualizarTabla" @eliminado="actualizarTabla" @cierraModal="closeModal"></Editar>
    </div>
</template>

<script>
import Tasas from '../../../services/Tasas'; 
import CorporateDataTable from '../../utils/CorporateDataTable.vue'
import TipoTasa from '../../../services/TipoTasas'; 
import Crear from './Crear.vue'; 
import Editar from './Editar.vue'; 

export default {
    name: 'Tasas',
    components:{Crear,Editar,CorporateDataTable},
    data:() => ({
        listadoTasas : [],
        showCrearTasa : false,
        listTipoTasa : [],
        showEditarTasa : false,
        dataTasa : [],
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Registro y mantenimiento de Tasas',
                    noRow : "No hay registros",
                    addTasa : "Añadir tasa",
                    tipoTasa : 'Tipo Tasa',
                    valor : 'Valor',
                    vigencia : 'Vigencia',
                    filterTipoTasa : "Filtrar tipo tasa...",
                    filterValor : "Filtrar valor...",
                    filterVigencia : "Filtrar vigencia...",
                }
            }else{
                return {
                    title : 'Rates',
                    noRow : "There are not records",
                    addTasa : "Add fee",
                    tipoTasa : 'Rate type',
                    valor : 'Worth',
                    vigencia : 'Validity',
                    filterTipoTasa : "Filter rate type...",
                    filterValor : "Filter worth...",
                    filterVigencia : "Filter validity...",
                }
            }
        },
        allFields(){
            return [
                { key: 'tipo_tasa', label: this.labels.tipoTasa, sortable: true, thClass: 'text-center', tdClass: 'text-start' },
                { key: 'valor', label: this.labels.valor, sortable: true, thClass: 'text-center', tdClass: 'text-end' },
                { key: 'vigencia', label: this.labels.vigencia, sortable: true, thClass: 'text-center', tdClass: 'text-end' },
            ]
        },
        tableFilterDefs(){
            return [
                { key: 'tipo_tasa', type: 'text', placeholder: this.labels.filterTipoTasa },
                { key: 'valor', type: 'text', placeholder: this.labels.filterValor },
                { key: 'vigencia', type: 'text', placeholder: this.labels.filterVigencia },
            ]
        },
        listadoTasasFormat() {
        return this.listadoTasas.map(item => ({
            ...item,
            tipo_tasa: this.nameTipoTasa(item.tipo_tasa)
        }));
    }
    },
    methods:{
        goBack() {
            this.$router.back()
        },
        createTasa(){
            this.showCrearTasa = true 
        },
        editTasa(id){
            Tasas.getTasaById(id) 
            .then((res) => { 
                this.dataTasa = res.data.tasa 
                this.showEditarTasa = true 
            })
            .catch((err) => console.log(err)) 
        },
        closeModal(val){
            this.showCrearTasa = val 
            this.showEditarTasa = val 
        },
        nameTipoTasa(numTipoTasa){
            // console.log(numTipoTasa); 
            let tipoTasa = this.listTipoTasa.find((tipTasa) => tipTasa.tipo_tasa === numTipoTasa) 
            return tipoTasa?.descripcion 
        },
        actualizarTabla(){
           Tasas.getAllTasas() 
            .then((res) => { 
                // console.log(res.data.listTasas); 
                this.listadoTasas = res.data.listTasas 
            })
            .catch((err) => { console.log(err) }) 

            TipoTasa.getAllTipoTasas() 
            .then((res) => { 
                // console.log(res.data.listTipoTasas); 
                this.listTipoTasa = res.data.listTipoTasas 
            })
            .catch((err) => { console.log(err) })  
        }
    },
    mounted(){
        Tasas.getAllTasas() 
        .then((res) => { 
            // console.log(res.data.listTasas); 
            this.listadoTasas = res.data.listTasas 
        })
        .catch((err) => { console.log(err) }) 

        TipoTasa.getAllTipoTasas() 
        .then((res) => { 
            // console.log(res.data.listTipoTasas); 
            this.listTipoTasa = res.data.listTipoTasas 
        })
        .catch((err) => { console.log(err) }) 
    }
}
</script>

<style lang="css">
  .b-table-cell-container { 
    padding: 15px !important;
  }
  .b-table-head-label { 
    padding-left: 34px !important;
  }
</style>
